<template>
    <div class="logo-container">
      <div class="logo-part pablo">Pablo</div>
      <div class="logo-part logic">logic</div>
    </div>
  </template>
  
  <script>
  export default {
  name: 'AnimatedLogo',
  mounted() {
    setTimeout(() => {
      this.$emit('animation-complete');
    }, 600); // Match this duration with the length of your animation
  }
};
  </script>
  
  <style scoped>
  .logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100vh;
  }
  
  .logo-part {
    position: absolute;
    font-size: 250px;
    font-weight: bold;
    color: #5595b7c2;
    font-family: Murray Hill, serif; /* Add this line to specify the font */
  }
  
  .pablo {
    animation: movePablo 2s forwards; /* Extended time for all movements */
    transform: translateX(100%);
    animation-delay: 0s;
  }
  
  .logic {
    animation: moveLogic 2s forwards; /* Extended time for all movements */
    transform: translateX(-100%);
    animation-delay: 0s;
  }
  
  @keyframes movePablo {
    0% {
      transform: translateX(100%);
      opacity: 0; /* Start with opacity 0 */
    }
    60% {
    opacity: 1; /* Fade in by 20% of the animation */
    }
    
    66% {
      transform: translateX(-25%); /* Cross and slightly pass logic */
    }
    66% {
      transform: translateX(-75%); /* Go past logic */
    }
    100% {
      transform: translateX(-25%); /* Return to overlap "lo" */
    }
  }
  
  @keyframes moveLogic {
    0% {
      transform: translateX(-100%);
      opacity: 0; /* Start with opacity 0 */
    }
    60% {
    opacity: 1; /* Fade in by 20% of the animation */
    }

    66% {
      transform: translateX(25%); /* Cross and slightly pass Pablo */
    }
    66% {
      transform: translateX(100%); /* Go past Pablo */
    }
    100% {
      transform: translateX(41.5%); /* Return to overlap "lo" */
    }
  }
  </style>
  